module.exports = __webpack_public_path__ + "0f678b11228abda17ef10cc75c8c8be4.MP3";